import styled from 'styled-components';

const Cell = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  cursor: pointer;

  padding: 8px;
  column-gap: 8px;
  border-radius: 6px;

  box-sizing: border-box;

  transition: background-color 150ms linear;

  &:hover {
    background-color: var(--wash-gray-default);
  }

  ${({ $selected }) =>
    $selected ? `background-color: var(--wash-gray-default);` : 'background-color: transparent;'}
`;

export { Cell };
